import { Button } from 'react-dsgov';
import { useState } from 'react';

interface IConfirmerProps {
  children: string;
  'data-testid'?: string;
  id?: string;
  args?: any;
  disabled?: boolean;
  asyncCall: (args: any) => Promise<any>;
}

function CustomConfirmer(props: IConfirmerProps) {
  const [loadingState, setLoadingState] = useState(false);

  return (
    <Button
      data-testid={props['data-testid']}
      id={props.id}
      primary
      small
      m={2}
      loading={loadingState}
      disabled={props.disabled || false}
      onClick={() => {
        setLoadingState(true);
        props.asyncCall(props.args).finally(() => {
          setLoadingState(false);
        });
      }}
    >
      {props.children}
    </Button>
  );
}

export default CustomConfirmer;
